import { SocialBusiness } from "@entities/socialBusiness";
import { getImageUrl } from "@hooks/utils/useUpload";
import { SocialBusinessLineItem } from "@interfaces/socialBusiness";
import { decodeTargetName } from "./commitment";

export const decodeSocialBusiness = async (
  socialBusiness: SocialBusiness
): Promise<SocialBusinessLineItem> => {
  const presignedUrl =
    socialBusiness.social_business_logo.length > 0
      ? await getImageUrl(socialBusiness.social_business_logo)
      : "";
  return {
    socialBusinessName: socialBusiness.social_business_name,
    socialBusinessBlurb: socialBusiness.social_business_blurb,
    socialBusinessLogo: presignedUrl,
    socialBusinessWebsite: socialBusiness.social_business_website,
    socialBusinessBeneficiaries: decodeTargetName(
      socialBusiness.social_business_beneficiaries
    ),
  };
};
